<!-- 对方人员设置委托 -->
<template>
    <div>
        <!-- <subComponents  ref="showSelectData"></subComponents> -->
        <el-dialog :visible.sync="dataActionBox.showStatus" :title="dataActionBox.boxTitle" append-to-body :close-on-click-modal="false" center width="80%" top="1rem">
            <el-form @submit.native.prevent class="baseForm" size="mini" label-position="right" label-width="120px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="是否拦截">
                            <el-radio-group v-model="sendDataInfo.isIntercept">
                                <el-radio-button label="0">否</el-radio-button>
                                <el-radio-button label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否使用">
                            <el-radio-group v-model="sendDataInfo.isUsed">
                                <el-radio-button label="0">否</el-radio-button>
                                <el-radio-button label="1">是</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="委托书效期" required>
                            <df-date :isType="true" v-model="sendDataInfo.terValidity"></df-date>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="委托书名称" required>
                            <el-select v-model="sendDataInfo.terName" style="width: 100%;" clearable>
                                <el-option v-for="(values) in dictionariesDatas" :key="values.diId" :label="values.diName" :value="values.diValue"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item class="elTable" label="委托书类型">
                            <div>
                                <el-radio-group v-model="sendDataInfo.terType">
                                    <el-radio-button label="1">单品委托</el-radio-button>
                                    <el-radio-button label="0">全品委托</el-radio-button>
                                </el-radio-group>
                            </div>
                            <div v-if="sendDataInfo.terType == 1">
                                <div style="margin:.6rem 0">
                                    <el-button type="primary" size="mini" @click="openSearch('853533363572736')">新增单品
                                    </el-button>
                                    <el-button type="primary" size="mini" @click="delLicense()">删除单品</el-button>
                                </div>
                                <el-table :data="sendDataInfo.descibSalesplicencedetailVo" height="220" border style="width: 100%" size="mini">
                                    <el-table-column label="选择操作" width="90">
                                        <template slot-scope="scope">
                                            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                                                <i class="el-icon-thumb"></i>
                                            </el-radio>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="bgmName" label="通用名称" show-overflow-tooltip>
                                    </el-table-column>
                                    <el-table-column prop="mne" label="助记码" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="spec" label="规格" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="manufacturer" label="生产厂商" show-overflow-tooltip>
                                    </el-table-column>
                                    <el-table-column prop="placeorigin" label="产地" show-overflow-tooltip>
                                    </el-table-column>
                                </el-table>
                            </div>

                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="委托书图片">
                            <el-upload class="upload-demo" :action="requesUrl + '/upload/fileupload'" :headers="token" :multiple="true" :on-success="fileUpload" :before-remove="beforeRemove" :before-upload="beforeUpload"
                                :file-list="fileList" list-type="picture">
                                <div style="display: flex;">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                    <el-button @click.stop="openFile1()" type="primary" icon="el-icon-upload" size="small">高拍仪上传</el-button>
                                </div>

                                <!-- <div slot="tip" class="el-upload__tip">不超过500kb</div> -->
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="备注">
                            <el-input v-model="sendDataInfo.remark" style="width: 100%;" type="textarea" clearable maxlength="200"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="initActionBox">取消</el-button>
                <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType == 0">保存</el-button>
                <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType == 1">保存</el-button>
            </div>
        </el-dialog>
        <!-- 检索方案弹窗 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <!-- <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth"
				@sendTitle="getSearchName" /> -->
            <SearchSchemeMultiple ref="searchSchemeMultiple" :id="seId" :parentSearchData="parentSearchData" :parentData="parentData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="DialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="getSelect">确认选择</el-button>
            </span>
        </el-dialog>
        <FileNewAction ref="FileNewAction" v-if="showFile" :showFile="showFile" @isshowFile="IsshowFile" @NewelectFileIds="changeFileIds"></FileNewAction>
        <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
            <el-table :data="dialogList" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import searchSchemeMultiple from "../byComponents/SearchSchemeMultiple.vue";
export default {
    name: "salesmanSettingUnit",
    props: [],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        searchSchemeMultiple,
    },
    data() {
        //这里存放数据
        return {
            token: {
                token: sessionStorage.getItem("token"),
            },
            dataActionBox: {
                showStatus: false,
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                salesId: "", //对方业务员id
                bgmIds: [], //单品明细
                terValidity: "", //日期
                isIntercept: 1, //是否拦截
                terType: 0, //委托类型
                filePath: '', //图片地址
                filePathArr: [],
                terName: "", //委托名
                isUsed: 1, //是否使用
                descibSalesplicencedetailVo: [],
                remark: "", //备注
            },
            formDataList: [],
            seTitle: "", //检索
            DialogVisible: false,
            seWidth: "0",
            seId: 0,
            selectedDataIndex: 0, //单品选择索引
            dictionariesDatas: [],
            requesUrl: "",
            imgUrl: "",
            fileList: [],
            showFile: false,
            addpushlist: {
                glTername: "", //证照名称
                sliTername: "",
                sliTernumber: "",
                sliReoffice: "",
                sliTervalidity: "",
                sliRedate: "",
                uploadVoList: [], //附件
                lityId: "",
                isIntercept: "1",
                isUsed: "1",
                remark: "", //备注
            },
            uploadVoList: [],
            parentSearchData: {},
            parentData: {
                type: "bgmId",
                list: [],
            },
            //----------------------------
            showDialog: false,
            dialogList: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        fileList: function (newValue, old) {
            console.log(newValue, old)

            if (newValue.length == 1 && !newValue[0].url?.split(`${this.$store.getters.getConfig.imgUrl}/`)[1]) {
                this.fileList = []
            }
        }
    },
    //方法集合
    methods: {

        openFile1() {//打开高拍仪组件
            this.showFile = true
        },
        IsshowFile(value) {
            this.showFile = value
            console.log(this.showFile)
        },
        changeFileIds(val) {
            console.log(val, this.fileList)
            if (this.dataActionBox.actionType == 0) {
                // this.fileList = []
                val.forEach(item => {
                    console.log(item);
                    this.fileList.push({
                        name: item.fileName,
                        url: this.imgUrl + "/" + item.fileUrl,
                    });
                })
                this.sendDataInfo.uploadVoList = val
                this.showFile = false
                this.$forceUpdate()



            } else {
                // this.fileList = []
                val.forEach(item => {
                    console.log(item);

                    this.fileList.push({
                        name: item.fileName,
                        url: this.imgUrl + "/" + item.fileUrl,
                    });
                })
                this.sendDataInfo.uploadVoList = val
                console.log(this.fileList);
                this.showFile = false
                this.$forceUpdate()



            }
            this.sendDataInfo.filePathArr = this.fileList.map(item => {
                return item.url.split(`${this.$store.getters.getConfig.imgUrl}/`)[1]
            })


        },
        //
        getSelect() {
            var mx = JSON.parse(JSON.stringify(this.$refs.searchSchemeMultiple.multipleSelection))
            // if(this.sendDataInfo.descibSalesplicencedetailVo){
            // 	mx.forEach(item=>{
            // 		if(this.sendDataInfo.descibSalesplicencedetailVo.findIndex(items=>items.bgmId==item.bgmId) == -1){
            // 			this.sendDataInfo.descibSalesplicencedetailVo.push(item)
            // 		}
            // 	})
            // }else{
            this.sendDataInfo.descibSalesplicencedetailVo = mx
            // }
            this.DialogVisible = false;
        },
        beforeUpload(file) {
            // console.log(file, this.sendDataInfo.uploadVoList);
            for (let i = 0; i < this.sendDataInfo.filePathArr.length; i++) {
                const v = this.sendDataInfo.filePathArr[i]
                if (v.fileName == file.name) {
                    this.$message({
                        type: "error",
                        message: "请勿重复添加",
                    })
                    return false
                }
            }
        },
        beforeRemove(file, fileList) {
            console.log(file, fileList)
            let fileArr = file.url.split(`${this.$store.getters.getConfig.imgUrl}/`)[1]
            if (this.sendDataInfo.filePathArr.length > 0) {
                this.sendDataInfo.filePathArr.forEach((item, index) => {
                    console.log(item, "+++++++++++++", fileArr);
                    if (item == fileArr) {
                        this.sendDataInfo.filePathArr.splice(index, 1)
                        this.fileList.splice(index, 1)
                    }
                })
            }
            if (this.sendDataInfo.uploadVoList?.length > 0) {
                this.sendDataInfo.uploadVoList.forEach((item, index) => {
                    if (item.fileUrl == fileArr) {
                        this.sendDataInfo.uploadVoList.splice(index, 1)
                    }
                })
            }
            this.sendDataInfo.filePath = this.sendDataInfo.filePathArr.join(',')
        },
        async fileUpload(event) {
            // console.log(event);
            setTimeout(() => {
                if (event.status == 200) {
                    event.result.forEach((item) => {
                        this.sendDataInfo.filePathArr.push(JSON.parse(JSON.stringify(item.fileUrl)))
                        this.fileList.push({
                            name: item.fileName,
                            status: item.status,
                            uid: item.uid,
                            url: this.$store.getters.getConfig.imgUrl + '/' + item.fileUrl
                        })
                        this.sendDataInfo.filePath = this.sendDataInfo.filePath + ',' + item.fileUrl
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: event.messsage
                    });
                }
            }, 100)
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId) {
            this.DialogVisible = true;
            this.seId = sId;
            if (this.sendDataInfo.descibSalesplicencedetailVo && this.sendDataInfo.descibSalesplicencedetailVo.length > 0) {
                this.parentData.list = this.sendDataInfo.descibSalesplicencedetailVo
            }
        },
        //检索带回数据
        changeInputModel(val) {
            console.log("返hui", val);
            if (val != "" || val != undefined) {
                //检测重复
                console.log(this.sendDataInfo.descibSalesplicencedetailVo)
                for (let i = 0; i < this.sendDataInfo.descibSalesplicencedetailVo.length; i++) {
                    const element = this.sendDataInfo.descibSalesplicencedetailVo[i];
                    if (val.bgmId == element.bgmId) {
                        this.$message({
                            message: "当前单品已存在，请选择其它商品",
                            type: "error",
                        });
                        return false;
                    }
                }
                this.DialogVisible = false; //关闭商品检索窗口
                //赋值
                this.sendDataInfo.descibSalesplicencedetailVo.push(val)

            } else {
                this.DialogVisible = false;
                this.$message({
                    message: "检索失败",
                    type: "error",
                });
            }
            console.log("检索返后", this.sendDataInfo);
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },

        //新增委托
        async sendDataAction() {
            if (this.sendDataInfo.terName == "") {
                this.$message({
                    message: "请填写委托书名称",
                    type: "error",
                });
                return false;
            }
            if (this.sendDataInfo.terType == 0) {
                //全品不需要明细
                this.sendDataInfo.descibSalesplicencedetailVo = [];
            }

            if (
                this.sendDataInfo.terType == 1 &&
                this.sendDataInfo.descibSalesplicencedetailVo.length < 1
            ) {
                this.$message({
                    message: "请添加单品商品",
                    type: "error",
                });
                return false;
            }
            this.sendDataInfo.bgmIds = []
            this.sendDataInfo.descibSalesplicencedetailVo.forEach(item => {
                this.sendDataInfo.bgmIds.push(item.bgmId);
            })
            this.sendDataInfo.filePath = this.sendDataInfo.filePathArr.toString()
            // this.sendDataInfo.uploadVoList = []
            this.$http.fromruleCheckSalsesFile({ filePaths: this.sendDataInfo.filePathArr }).then(res => {
                console.log(res);
                if (res.status == 200||res.status==200) {
                    let flag = -1;
                    this.dialogList = []
                    if (res.result != null && res.result.length > 0) {
                        res.result.forEach(item => {
                            this.dialogList.push(item)
                        })
                        flag = this.dialogList.findIndex(
                            (item) => item.level == 0
                        );
                        this.showDialog = true;
                    }
                    if (flag == -1) {
                        this.$parent.pushData(this.sendDataInfo, this.dataActionBox.actionType)
                        this.dataActionBox.showStatus = false
                    } else {
                        this.showDialog = true;
                    }
                }else{
                    this.$message.error(res.message)
                }
            })

        },

        //删除单品
        delLicense() {
            if (this.sendDataInfo.descibSalesplicencedetailVo.length < 1) {
                this.$message({
                    message: "请先添加单品",
                    type: "error",
                });
                return false;
            }
            this.sendDataInfo.descibSalesplicencedetailVo.splice(this.selectedDataIndex, 1);
            this.sendDataInfo.bgmIds.splice(this.selectedDataIndex, 1);
            this.selectedDataIndex = 0;
        },
        //上传图片
        uploadFileAction() {
            this.$refs.fileInput.click();
        },

        //取消新增
        initActionBox() {
            this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.dataActionBox.showStatus = false;
                    this.init();
                    this.$refs[formName][0].resetFields();
                })
                .catch(() => { });
        },
        //初始化
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.sendDataInfo.isIntercept = 1;
            this.sendDataInfo.terType = 0;
            this.sendDataInfo.isUsed = 1;
            this.sendDataInfo.descibSalesplicencedetailVo = [];
            this.sendDataInfo.filePathArr = [];
            this.sendDataInfo.bgmIds = [];
            this.sendDataInfo.terValidity = this.$moment().valueOf();
        },
        // 默认值
        initDefaultValue() {
            this.formDataList.forEach((item) => {
                if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
                    this.sendDataInfo[item.entityField] = item.defaultValue;
                }
            });
            this.sendDataInfo.bgmIds = [];
            this.sendDataInfo.filePathArr = [];
            this.sendDataInfo.descibSalesplicencedetailVo = [];
        },

        //父级传入
        openBox(cate, oldData = {}, formData) {
            this.formDataList = formData
            this.dataActionBox.actionType = cate;
            this.fileList = []
            oldData = JSON.parse(JSON.stringify(oldData));
            // this.init();
            if (cate == 0) {
                this.dataActionBox.boxTitle = "新增委托信息";
                this.initDefaultValue();
                this.dataActionBox.showStatus = true;
                console.log("新增sendDataInfo", this.sendDataInfo);
            } else {
                this.dataActionBox.boxTitle = "编辑委托信息";
                console.log(oldData, "+++")
                this.$nextTick(() => {
                    for (let key in oldData) {
                        if (key == 'filePathArr') {
                            oldData[key].forEach((item, index) => {
                                this.fileList.push({
                                    url: this.imgUrl + '/' + item,
                                })
                            })
                            this.$set(this.sendDataInfo, key, oldData[key])
                        } else {
                            this.$set(this.sendDataInfo, key, oldData[key]);
                        }
                    }
                })

                if (this.sendDataInfo.descibSalesplicencedetailVo == null) {
                    this.sendDataInfo.descibSalesplicencedetailVo = []
                }
                this.dataActionBox.showStatus = true;
            }
        },
        //获取委托书名称
        async getCateDictionariesDatas() {
            let responseData = await this.$http.getCateDictionariesData({
                ids: [45],
            });
            if (responseData.status == 200) {
                this.dictionariesDatas = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        imgur() {
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.imgur();
        this.getCateDictionariesDatas()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
.baseForm .elTable .el-form-item__content {
    width: 80% !important;
}
</style>